import type { FireflyRuntime } from "@squide/firefly";

export function handleForbiddenError(error: Error, runtime: FireflyRuntime) {
    runtime.logger.withText("[web-app] Access denied, redirecting home:").withError(error).warning();

    window.location.href = "/";
}
